import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import CartPromos from '@/plugins/graphql/queries/v2/cart-promos.gql';
import CartPromoDelete from '@/plugins/graphql/mutations/v2/cart-promo-delete.gql';
import CartPromoUpdateStatus from '@/plugins/graphql/mutations/v2/cart-promo-update-status.gql';
import { Getter, Mutation } from 'vuex-class';
import { successfulDestroy, successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import { CartPromoModel } from '@/helpers/entities/models/CartPromoModel';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import Paginator from '@/components/v2/Paginator.vue';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let CartPromoManager = class CartPromoManager extends mixins(FormMixin, PaginatorMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.cartPromos = [];
        this.selectedCartPromoUuid = null;
    }
    toggleConfirmation(uuid) {
        this.selectedCartPromoUuid = uuid;
        this.showConfirmationDialog();
    }
    goToCartPromoDetailsPage(uuid) {
        this.cartPromoAction('START EDIT');
        this.$router.push({
            name: 'ecommerce-cart-promos-edit',
            params: {
                uuid,
            },
        });
    }
    toggleUpdateStatus(active, cartPromoUuid) {
        this.updateCartPromo(active, cartPromoUuid);
    }
    async updateCartPromo(active, cartPromoUuid) {
        this.requestOnFlight();
        await this.updateActiveStatus(active, cartPromoUuid)
            .then(() => {
            const msg = successfulUpdate('Cart Promo Active Status');
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async updateActiveStatus(active, cartPromoUuid) {
        if (active === null) {
            active = false;
        }
        await this.$apollo.mutate({
            mutation: CartPromoUpdateStatus,
            variables: {
                input: {
                    cartPromoUuid,
                    status: active,
                },
            },
        });
    }
    async uponConfirm() {
        this.requestOnFlight();
        await this.delete()
            .then(() => {
            const msg = successfulDestroy('Cart Promo');
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
            this.hideConfirmationDialog();
        });
    }
    async delete() {
        const { appUuid } = this;
        if (!this.selectedCartPromoUuid) {
            return;
        }
        await this.$apollo.mutate({
            mutation: CartPromoDelete,
            variables: {
                input: {
                    cartPromoUuid: this.selectedCartPromoUuid,
                },
            },
            update: (cache, { data }) => {
                const { cartPromo } = data.cartPromoDelete;
                const queryOptions = {
                    query: CartPromos,
                    variables: {
                        appUuid,
                    },
                };
                const { fetchAllCartPromo } = cache.readQuery({
                    ...queryOptions,
                });
                const deletedCartPromo = (sm) => {
                    return sm.node.uuid !== cartPromo.uuid;
                };
                cache.writeQuery({
                    ...queryOptions,
                    data: {
                        fetchAllCartPromo: {
                            ...fetchAllCartPromo,
                            edges: fetchAllCartPromo.edges.filter(deletedCartPromo),
                        },
                    },
                });
            },
        });
    }
};
__decorate([
    Getter('appUuid')
], CartPromoManager.prototype, "appUuid", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], CartPromoManager.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], CartPromoManager.prototype, "hideConfirmationDialog", void 0);
CartPromoManager = __decorate([
    Component({
        apollo: {
            cartPromos: {
                query: CartPromos,
                variables() {
                    return {
                        appUuid: this.appUuid,
                        first: this.perPage,
                        after: this.startCursor,
                    };
                },
                update({ fetchAllCartPromo }) {
                    const { edges, pageInfo, totalCount } = fetchAllCartPromo;
                    const cartPromoNodes = (cartPromo) => {
                        return new CartPromoModel(cartPromo.node);
                    };
                    this.pageInfo = pageInfo;
                    this.totalCount = totalCount;
                    return edges.map(cartPromoNodes);
                },
            },
        },
        components: {
            ConfirmationDialog,
            BaseOverlayLoader,
            Paginator,
        },
    })
], CartPromoManager);
export default CartPromoManager;
